
import React, { useState, useEffect } from "react";
import "./css/listadoRepuestos.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import axios from "axios";
import { Server } from "../../constants";
import Productos from "./Productos";

const Detalle = ({ label, value }) => (
    <p className="resultado-detalle">
        <strong>{label}:</strong> {value}
    </p>
);

const ListadoRepuestos = ({anio, vehicle}) => {
    const [productsItem, setProductsItem] = useState([]);

    const getProductos = async () => {
        try {
            if (!vehicle) {
            console.error("El valor de vehicle es invalido:", vehicle);
            return;
        }
        const trimmedVehicle = vehicle.trim();
            const response = await axios.get(`${Server}/api/repuestos/getRepuestosModel/${trimmedVehicle}`);
            if (response && response.data && response.data.data) {
                setProductsItem(
                    response.data.data.map((modelo) => ({
                        id: modelo.id_part,
                        img: modelo.imagen,
                        name: modelo.description,
                        price: modelo.cost,
                    }))
                );
            }
        } catch (error) {
            console.error("Error", error);
            console.error("Error al obtener los productos:", error);
        }
    };

    useEffect(() => {
        getProductos();
    }, [vehicle]);
    return (
        <Container>
            <div className="Filtro-vehiculo">
                <h3>Encuentre Su Repuesto</h3>
            </div>
            <div className="detalles-busqueda">
                <h4 className="detalles-title">Detalles de búsqueda</h4>
                <hr/>
                <Row>
                    <Col md={4} className="text-center">
                        <img
                            src="https://kerner.hyundai.com.ec/images/catalogo/modelos/principales/1031.png"
                            className="resultado-imagen mt-4"
                            alt="Imagen del modelo Hyundai Tucson"
                        />
                    </Col>
                    <Col md={8}>
                        <h5 className="resultado-titulo mt-4">
                            Repuestos - Hyundai Tucson - 2024
                        </h5>
                        <Row>
                            <Col>
                                <Detalle label="CC" value="2497" />
                                <Detalle label="Tipo" value="2.5L MPI" />
                                <Detalle label="Tracción" value="2WD" />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="justify-content-end">
                    <Button
                        type="button"
                        className="btn btn-outline-primary cambiar-vehiculo-btn"
                        aria-label="Cambiar Vehículo"
                        onClick={() => alert("wr")}
                    >
                        Cambiar Vehículo
                    </Button>
                </Row>
            </div>
            <div className="productos-separado mt-4 p-1">
                <Productos productsItem={productsItem} />
            </div>
        </Container>
    );
};

export default ListadoRepuestos;
